import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getBlogById } from "../../api/BlogCategoryService";

export default function BlogCategoryView() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategory = async () => {
      try {
        if (!slug) {
          navigate("/blogcategory");
          return;
        }

        setLoading(true);

        const res = await getBlogById(slug);

        const categoryData = res?.data || res;

        setCategory(categoryData);
      } catch (error) {
        console.error("Failed to fetch blog category:", error);
        setCategory(null);
      } finally {
        setLoading(false);
      }
    };

    loadCategory();
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="container-fluid p-4">
        <h5>Loading Blog Category...</h5>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="container-fluid p-4">
        <div className="card p-3">
          <h5>Blog Category Not Found</h5>

          <button
            className="btn btn-secondary mt-3"
            style={{ width: "fit-content" }}
            onClick={() => navigate("/blogcategory")}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <h5 className="mb-4">View Blog Category</h5>

        <div className="row">
          <div className="col-md-6 mb-3">
            <b>Name : </b>
            {category.name || "-"}
          </div>

          <div className="col-md-6 mb-3">
            <b>Slug : </b>
            {category.slug || "-"}
          </div>

          <div className="col-md-12 mb-3">
            <b>Description : </b>
            {category.description || "-"}
          </div>

          <div className="col-md-4 mb-3">
            <b>Status : </b>

            <span
              className={`badge ms-2 ${
                category.status === "ACTIVE" ? "bg-success" : "bg-secondary"
              }`}
            >
              {category.status || "-"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
